/**
 * 메인페이지 데이터 캐시 — 모듈 레벨 싱글턴
 * 페이지 재방문 시 데이터를 즉시 표시하기 위해 사용
 */
const cache = {
  newsData: null,
  userId: null,
  isLoaded: false,
  carouselData: null,
  popupBannerData: {},
  popupListData: {},
}

const latestCache = { data: null }

export function getMainPageCache() {
  return cache
}

export function setMainPageCache(newsData) {
  cache.newsData = newsData
  cache.isLoaded = true
}

export function setMainPageUserId(userId) {
  cache.userId = userId
}

export function getCarouselFirstSlide() {
  return cache.carouselData
}

export function setCarouselFirstSlide(slide) {
  cache.carouselData = slide
}

export function getPopupBannerCache(boardId) {
  return cache.popupBannerData[boardId] ?? null
}

export function setPopupBannerCache(boardId, banners) {
  cache.popupBannerData[boardId] = banners
}

export function getPopupListCache(pageContext) {
  return cache.popupListData[pageContext] ?? null
}

export function setPopupListCache(pageContext, popups) {
  cache.popupListData[pageContext] = popups
}

const popupPrefetchPromises = {}

const sortPopupList = list => {
  const now = Date.now()
  return (list || [])
    .filter(p => p && p.isActive !== false)
    .filter(p => {
      const start = p.startDate ? new Date(p.startDate).getTime() : null
      const end = p.endDate ? new Date(p.endDate).getTime() : null
      if (start && now < start) return false
      if (end && now > end) return false
      return true
    })
    .slice()
    .sort((a, b) => (b.displayPriority ?? 0) - (a.displayPriority ?? 0))
}

/**
 * 팝업 목록을 비동기로 prefetch해 캐시에 채워둔다.
 * 동일 컨텍스트로 동시에 여러 번 호출되어도 중복 요청은 발생하지 않는다.
 * MainPopupBanner는 cache-first 구조라, 이 prefetch가 끝나 있으면 즉시 표시된다.
 */
export async function prefetchPopupList(pageContext) {
  if (cache.popupListData[pageContext]) return cache.popupListData[pageContext]
  if (popupPrefetchPromises[pageContext]) return popupPrefetchPromises[pageContext]

  const { getPopupsByContext } = await import('@/api/popupApi')
  const promise = getPopupsByContext(pageContext)
    .then(data => {
      const sorted = sortPopupList(data?.popups || [])
      cache.popupListData[pageContext] = sorted
      return sorted
    })
    .finally(() => {
      delete popupPrefetchPromises[pageContext]
    })

  popupPrefetchPromises[pageContext] = promise
  return promise
}

export function getLatestSajuCache() {
  return latestCache.data
}

export function setLatestSajuCache(data) {
  latestCache.data = data
}

/** 로그아웃/계정 전환 시 메인페이지 모듈 레벨 캐시 일괄 초기화 */
export function resetMainPageCache() {
  cache.newsData = null
  cache.userId = null
  cache.isLoaded = false
  cache.carouselData = null
  cache.popupBannerData = {}
  cache.popupListData = {}
  latestCache.data = null
}
